export default "__VITE_ASSET__C6Z2KRUb__"